import React from "react";
import "./SourceModal.scss";

interface SourceModalProps {
    open: boolean;
    onClose: () => void;
}

// Mock-Daten für KPIs inklusive Prozentwerte
const kpiData = {
    umsatzGeneriert: {
        value: "50.000€",
        change: "+10%"
    },
    anfragenGewonnen: {
        value: 120,
        change: "+15%"
    },
    dauerAnfrageBisKunde: {
        value: "3 Tage",
        change: "+8%"
    },
    conversionRate: {
        value: "25%",
        change: "+5%"
    }
};

const SourceModal: React.FC<SourceModalProps> = ({ open, onClose }) => {
    if (!open) return null;

    return (
        <div className="source-modal-overlay" onClick={onClose}>
            <div className="source-modal-content" onClick={(e) => e.stopPropagation()}>
                <i className="fa-solid fa-close" onClick={onClose} />
                <h2>Details zur Lead-Quelle</h2>
                <p><strong>Quelle:</strong> </p>
                <div className="source-header-container">
                    <div className="source-header">
                        <a>
                            <div className="source-header-logo"></div>
                            <div className="source-header-text">VP Verbund Pflegehilfe</div>
                        </a>
                    </div>
                </div>
                <p>
                    <strong>Beschreibung:</strong> <br></br>Der Verbund Pflegehilfe unterstützt als größte Pflegeberatung Deutschlands Pflegebedürftige, Angehörige und pflegende Angehörige. Seit der Gründung im Jahr 2008 wurden bereits über 1,5 Millionen Beratungsgespräche geführt.<br></br><br></br>In Mainz ansässig berät der Verbund Pflegehilfe kostenlos für den Raum Deutschland, Schweiz und Österreich. Im Pflegehilfe-Portal finden Sie Informationen zu allen pflegerelevanten Themen und einem selbstbestimmten Leben im Alter.

                </p>
                <p>
                    <a href="https://www.pflegehilfe.org" target="_blank" rel="noreferrer">
                        Zur Webseite von VP Verbund Pflegehilfe
                    </a>
                </p>
                <div className="kpi-container">
                    <h3>KPIs</h3>
                    <div className="kpi-grid">
                        <div className="kpi-box">
                            <div className="kpi-header">
                                <strong>Umsatz generiert:</strong>
                                <span className="kpi-arrow">
                                    <i className="fa-solid fa-arrow-up"></i> {kpiData.umsatzGeneriert.change}
                                </span>
                            </div>
                            <p>{kpiData.umsatzGeneriert.value}</p>
                        </div>
                        <div className="kpi-box">
                            <div className="kpi-header">
                                <strong>Anfragen gewonnen:</strong>
                                <span className="kpi-arrow">
                                    <i className="fa-solid fa-arrow-up"></i> {kpiData.anfragenGewonnen.change}
                                </span>
                            </div>
                            <p>{kpiData.anfragenGewonnen.value}</p>
                        </div>
                        <div className="kpi-box">
                            <div className="kpi-header">
                                <strong>Dauer Anfrage bis Kunde:</strong>
                                <span className="kpi-arrow">
                                    <i className="fa-solid fa-arrow-up"></i> {kpiData.dauerAnfrageBisKunde.change}
                                </span>
                            </div>
                            <p>{kpiData.dauerAnfrageBisKunde.value}</p>
                        </div>
                        <div className="kpi-box">
                            <div className="kpi-header">
                                <strong>Avg. Conversion Rate:</strong>
                                <span className="kpi-arrow">
                                    <i className="fa-solid fa-arrow-up"></i> {kpiData.conversionRate.change}
                                </span>
                            </div>
                            <p>{kpiData.conversionRate.value}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SourceModal;
